<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<mat-tab-group [selectedIndex]="selectedIndex">
  <mat-tab *ngIf="selectedBundesland === 'Berlin'" label="Berlinbericht">
    <app-berlin-bericht [berlinWetterbericht]="rbbDocument?.berlinbericht?.berlinbericht"></app-berlin-bericht>
  </mat-tab>
  <mat-tab label="Berlin-/Brandenburg Kurzbericht">
    <app-berlin-brandenburg-kurz-bericht
      [berlinBrandenburgKurzBericht]="rbbDocument?.blnBrbbericht?.berlinBrandenburgKurzBericht"></app-berlin-brandenburg-kurz-bericht>
  </mat-tab>
  <mat-tab label="Brandenburg Langbericht">
    <app-brandenburg-lang-bericht
      [brandenburgLangBericht]="rbbDocument?.blnBrbbericht?.brandenburgLangBericht"></app-brandenburg-lang-bericht>
  </mat-tab>
  <mat-tab label="Berlin-/Brandenburg Onlinebericht">
    <app-berlin-brandenburg-online-bericht
      [berlinBrandenburgOnlineBericht]="rbbDocument?.blnBrbbericht?.berlinBrandenburgOnlineBericht"></app-berlin-brandenburg-online-bericht>
  </mat-tab>
  <mat-tab label="Berlin-/Brandenburg Videotext">
    <app-berlin-brandenburg-videotext-bericht
      [setBerlinBrandenburgVideotextAussichten]="rbbDocument?.blnBrbbericht?.berlinBrandenburgVideotextAussichten"
      [berlinBrandenburgVideotextVorhersagen]="rbbDocument?.blnBrbbericht?.berlinBrandenburgVideotextVorhersagen">
    </app-berlin-brandenburg-videotext-bericht>
  </mat-tab>
  <mat-tab label="Inforadio">
    <app-inforadio-text-bericht
      [infoRadioTexte]="rbbDocument?.blnBrbbericht?.inforadioTexte"></app-inforadio-text-bericht>
  </mat-tab>
  <mat-tab label="Schlagzeile Wetterblitz">
    <app-schlagzeile-wetterblitz-bericht [wetterblitzSchlagzeile]="rbbDocument?.wetterblitz?.wetterblitzSchlagzeile">
    </app-schlagzeile-wetterblitz-bericht>
  </mat-tab>
  <mat-tab label="Deutschlandwetter">
    <app-deutschlandwetter-bericht [deutschlandwetterOpenMedia]="rbbDocument?.deutschlandwetter?.openMedia">
    </app-deutschlandwetter-bericht>
  </mat-tab>
  <mat-tab label="Biowetter">
    <app-rbb-biowetter-bericht [biowetter]="rbbDocument?.biowetter"></app-rbb-biowetter-bericht>
  </mat-tab>
  <mat-tab label="PDF">
    <app-wetter-karte-pdf-bericht [wetterPdf]="rbbDocument?.wetterPdf"></app-wetter-karte-pdf-bericht>
  </mat-tab>
  <mat-tab label="Spezialwetter">
    <app-spezialwetter-bericht [spezialwetter]="rbbDocument?.spezialwetter"></app-spezialwetter-bericht>
  </mat-tab>
</mat-tab-group>
